import { type Money as MoneyValue } from '@/lib/money'
import { formatMoney, formatNPR } from '@/lib/format'
import { cn } from '@/lib/utils'

interface MoneyProps {
  value: MoneyValue | null | undefined
  /** Prefix with "Rs". Off inside a column that already has a currency header. */
  currency?: boolean
  /** Drop the paisa, for a book figure the design shows whole. */
  whole?: boolean
  className?: string
}

/**
 * Renders a money value. Neutral by design — this component never colours.
 * Gain/loss colour belongs to <Change>, so that a colour in a data region
 * always means direction and never decoration.
 */
export default function Money({ value, currency = false, whole = false, className }: MoneyProps) {
  if (value === null || value === undefined) {
    return <span className={cn('tnum text-muted-foreground', className)}>—</span>
  }
  return (
    <span className={cn('tnum', className)} data-numeric>
      {currency ? formatNPR(value, { whole }) : formatMoney(value, { whole })}
    </span>
  )
}
